import { Stack, Button } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';

/**
 * ApprovalActionBar Component
 * Standard approve/reject/edit action buttons
 */

interface ApprovalActionBarProps {
  onApprove: () => void;
  onReject: () => void;
  onEdit?: () => void;
  approveLabel?: string;
  rejectLabel?: string;
  editLabel?: string;
  disabled?: boolean;
}

export const ApprovalActionBar: React.FC<ApprovalActionBarProps> = ({
  onApprove,
  onReject,
  onEdit,
  approveLabel = "Approve",
  rejectLabel = "Reject",
  editLabel = "Edit",
  disabled = false
}) => {
  return (
    <Stack direction="row" spacing={2} justifyContent="flex-end">
      <Button
        variant="outlined"
        color="error"
        startIcon={<CloseIcon />}
        onClick={onReject}
        disabled={disabled}
      >
        {rejectLabel}
      </Button>

      {onEdit && (
        <Button
          variant="outlined"
          startIcon={<EditIcon />}
          onClick={onEdit}
          disabled={disabled}
        >
          {editLabel}
        </Button>
      )}

      <Button
        variant="contained"
        color="success"
        startIcon={<CheckIcon />}
        onClick={onApprove}
        disabled={disabled}
      >
        {approveLabel}
      </Button>
    </Stack>
  );
};
